import * as React from 'react';

import transfixLogo from '../assets/transfix-logo.png';

export default function TransfixLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return (
    <img
      src={transfixLogo}
      alt='Transfix'
      className='inline-block h-4 w-auto max-w-[90px] object-contain object-left'
      {...props}
    />
  );
}
